import React, { FC } from "react";
import classes from "./style/UI_ITOModuleSubTitle.module.css";

interface IUI_ITOModuleSubTitle {
  title: string;
}

export const UI_ITOModuleSubTitle: FC<IUI_ITOModuleSubTitle> = ({ title }) => {
  return <div className={classes.subtitle}>{title}</div>;
};
